import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { globals } from '@app/config/globals';
import { profile_access_module } from '@app/config/role-name.enum';
import { GenericModalComponent } from '@app/helpers/generic-modal-component';
import { validatorAtLeastOneCheckboxFn, validatorRutFn } from '@app/helpers/validator';
import { IDataGenericText } from '@app/interfaces/idata-grouped';
import { ConstantsService } from '@app/services/constants.service';
import { DataService } from '@app/services/data.service';
import { EmployerService } from '@app/services/employer.service';
import { HelpService } from '@app/services/help.service';
import { UserService } from '@app/services/user.service';
import { privilegesDetails, userRoles, } from 'functions/src/help/role-name.enum';
import { status_code } from 'functions/src/help/status-query';
import { BehaviorSubject } from 'rxjs';
import { FormGroupCheckboxMultiComponent } from '../form-group/form-group-checkbox-multi/form-group-checkbox-multi.component';

@Component({
  selector: 'employer-user-modal',
  templateUrl: './employer-user-modal.component.html',
  styleUrls: ['./employer-user-modal.component.css'],
})
export class EmployerUserModalComponent extends GenericModalComponent implements OnInit {

  public _id = 0;
  public _idCurrentUser = 0;
  public currentRecord: any = undefined;
  public userRoles = userRoles;
  public privilegesDetails = privilegesDetails;
  selectedRole: string = null;
  isCollapsed = true;

  buttonLabelShow = 'Ocultar privilegios de cada perfil';
  buttonLabelHide = 'Ver privilegios de cada perfil';
  buttonLabel = this.buttonLabelHide;

  @Output() modalClosed = new EventEmitter<void>();
  @Output() eventContactForm = new EventEmitter<null>();

  @ViewChild('inputInstitution') inputInstitution: FormGroupCheckboxMultiComponent;

  @Input() dataSelectInstitution!: BehaviorSubject<Array<IDataGenericText>>;
  public institutions: Array<IDataGenericText> = [];
  public hasCreditsInterview: boolean = false;
  @ViewChild('userPrivilegesInfo', { static: true })
  userPrivilegesInfo: ElementRef;
  public institutionSelected: Array<string> = [];

  constructor(
    private userService: UserService,
    public helpService: HelpService,
    public constantsService: ConstantsService,
    public employerService: EmployerService,
    private dataService: DataService
  ) {
    super('modal-user-new', 'form-carousel-school-user');
  }

  ngOnInit(): void {

    this.createFormGroup();

    if (this.dataSelectInstitution) {
      this.dataSelectInstitution.subscribe((data) => {
        this.institutions = data;
        this.helpService.setFormArrayGeneric(this.optionInstitution, this.institutions.length)

        this._formGroupModal.reset()

        if (this.institutions.length > 1 && this.userService.hasAccessToModule(profile_access_module.employer_user)) {
          this.optionInstitution.enable();
        }
        else {
          this.optionInstitution.disable();
        }
      });
    }
  }

  calculateRowspan(module: any): number {
    return module.functions.length;
  }

  createFormGroup() {
    this._formGroupModal = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      userSurname: new FormControl('', [Validators.required]),
      userDNI: new FormControl('', [Validators.required, validatorRutFn(true)]),
      userPhoneNumber: new FormControl('', [Validators.required, Validators.pattern(globals.pattern.phone_8digits),]),
      userEmail: new FormControl('', [Validators.required, Validators.pattern(globals.pattern.email),]),
      userRole: new FormControl(null, [Validators.required]),
      optionInstitution: new FormArray([], [Validators.required, validatorAtLeastOneCheckboxFn()]),
    });

    if (!this.userService.hasAccessToModule(profile_access_module.employer_user)) {
      this.optionInstitution.disable();
    }
  }

  onRoleChange(role: string) {
    this.selectedRole = role;
    this.userRole.setValue(role);
  }

  validateStepData() {
    this.validateStepInputData();

    this.institutionSelected = [];

    if (!(this.institutions.length > 1)) {
      return;
    }

    if (this.institutions.length > 1) {

      this.institutionSelected = this.helpService.getFormArrayGenericTextValues(this.optionInstitution, this.institutions);
    }
  }

  setCreate(hasCreditsInterview: boolean) {

    this.togglePrivilegesInfo(false);

    this.isLoadingRequest = false;
    this.hasCreditsInterview = hasCreditsInterview;
    this._formGroupModal.markAsUntouched();
    this.userEmail.enable();
    if (this._id > 0) {
      this._formGroupModal.reset();
      this.resetStepCarousel();
      this.currentRecord = undefined;
      this._id = 0;
      this.selectedRole = null;
    }
    this.optionInstitution.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.userRole.enable();
    this.userDNI.enable();
    this.modalShow()
    this.scriptService.initPopover();
    this._idCurrentUser = +this.userService.getIdCurrentUser();
  }

  setUpdate(record: any, hasCreditsInterview: boolean, actionShowModal: boolean = true) {

    this.togglePrivilegesInfo(false);
    this.isLoadingRequest = false;
    this.hasCreditsInterview = hasCreditsInterview;
    this._formGroupModal.markAsUntouched();
    this.resetStepCarousel();
    this.currentRecord = record;
    this._id = record._idUser;
    this._idCurrentUser = +this.userService.getIdCurrentUser();
    this.userName.setValue(record.userName);
    this.userSurname.setValue(record.userSurname);
    this.userDNI.setValue(record.userDNI);
    this.userPhoneNumber.setValue(record.userPhoneNumber?.slice(-8));
    this.userEmail.setValue(record.userEmail);
    this.userRole.setValue(record.userRole);

    this.userDNI.enable();

    if (this.userDNI.valid) {
      this.userDNI.disable();
    }

    const allIdEmployer = Array.isArray(record?.employerList) ? record.employerList.map(e => { return +e._id }) : [];

    this.optionInstitution.controls.forEach((control, index) => {
      const institutionId = +this.institutions[index].id;
      const isChecked = allIdEmployer.includes(institutionId);
      control.setValue(isChecked, { emitEvent: false });
    });

    setTimeout(() => {
      if (this.inputInstitution) {
        this.inputInstitution.getCountSelectedValues();
      }
    }, 50);


    this.selectedRole = record.userRole;
    this.userEmail.disable();

    if (+this.userService.getIdCurrentUser() === +this._id) {
      this.userRole.disable();
    }
    else {
      this.userRole.enable();
    }

    if (actionShowModal) {
      this.modalShow()
    }
    this.scriptService.initPopover();
  }

  addUser(event: any) {
    event.preventDefault();

    this._formGroupModal.markAllAsTouched();

    if (this._formGroupModal.invalid) return;

    if (this.userService.isAdminEmployer()) {
      this.showStepSuccess();
      return;
    }

    let req = {
      _idEmployer: this.userService.getIdEmployer(),
      userName: this.userName.value,
      userSurname: this.userSurname.value,
      userDNI: this.userDNI.value,
      userPhoneNumber: '+569' + this.userPhoneNumber.value,
      userEmail: this.userEmail.value,
      userRole: this.userRole.value,
      idEmployers: this.institutions.length > 1 && this.optionInstitution.enable ? this.helpService.getFormArrayGenericIdValues(this.optionInstitution, this.institutions) : ["" + this.userService.getIdEmployer()],
    };

    this.isLoadingRequest = true;

    this.userService.saveUserByEmployer(this._id, req).subscribe({
      next: (res) => {
        if (res.status_code === status_code.duplicate) {
          this.errorMessage = res;
          this.showStepError();
          return;
        }

        if (res.status_code !== status_code.success) {
          this.errorMessage = {};
          this.showStepError();
          return;
        }

        this.errorMessage = {};

        this.showStepSuccess();

        this.dataService.nextSharedData({ module: 'employer-user-update' })

        if (this._id === 0) {
          this._id = res._id;
        } else if (this._id === this._idCurrentUser) {
          this.userService.setUserName(this.currentRecord.userName);
          this.userService.setUserSurname(this.currentRecord.userSurname);
        }

      },
      error: (err) => {
        this.errorMessage = {};
        this.showStepError();
        console.error(err);
      },
    });
  }

  togglePrivilegesInfo(colapse: boolean): void {
    this.isCollapsed = colapse;
    const element = this.userPrivilegesInfo.nativeElement;
    if (this.isCollapsed) {
      element.classList.add('show');
      this.buttonLabel = this.buttonLabelShow;
    } else {
      element.classList.remove('show');
      this.buttonLabel = this.buttonLabelHide;
    }
    this.isCollapsed = !this.isCollapsed;
  }

  onClickContactForm(event: MouseEvent) {
    event.preventDefault();
    this.closeModal();
    this.eventContactForm.next(null);
  }

  getUserEmployer() {

    this.modalName = 'modal-employer-user-global'
    this.carouselName = 'form-carousel-edit-global';

    setTimeout(() => {
      this.modalShow();
    }, 100);

    this.isLoadingPage = true;


    this.userService
      .getUserByEmployer(this.userService.getIdCurrentUser())
      .subscribe(
        (res: any) => {

          if (res?.status_code === status_code.success && res.results && res?.results[0]) {

            this.institutions = res?.resultsInstitution.map((e: any) => { return { id: e._id, text: e.employerName } });


            this.helpService.setFormArrayGeneric(this.optionInstitution, this.institutions.length)

            if (this.institutions.length > 1 && this.userService.hasAccessToModule(profile_access_module.employer_user)) {
              this.optionInstitution.enable();
            }
            else {
              this.optionInstitution.disable();
            }

            this.setUpdate(res?.results[0], +res?.results[0].hasCreditsInterview > 0, false);
          }

          this.isLoadingPage = false;
        }
      );
  }

  get userName() { return this._formGroupModal.get('userName') as FormControl; }
  get userSurname() { return this._formGroupModal.get('userSurname') as FormControl; }
  get userDNI() { return this._formGroupModal.get('userDNI') as FormControl; }
  get userPhoneNumber() { return this._formGroupModal.get('userPhoneNumber') as FormControl; }
  get userEmail() { return this._formGroupModal.get('userEmail') as FormControl; }
  get userRole() { return this._formGroupModal.get('userRole') as FormControl; }
  get optionInstitution() { return this._formGroupModal.get('optionInstitution') as FormArray; }
}
